import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseMaTableComponent } from '../../../shared';
import { PrtTemplateComponent } from '../prt-template';


/**
* Second page of PDF print.
*/
@Component({
	selector: 'prt-measures-page',
	templateUrl: './prt-measures-page.component.html',
	imports: [
		PrtTemplateComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class PrintMeasuresPageComponent extends BaseMaTableComponent {

	@Input() today: Date | null = null;


	/**
	* Get wedge angle in AP view.
	*/
	get ap_wedgeAngle(): string {
		return this.printMeasures?.rpm_ap_angle || this.printMeasures?.rpm_ap_angle === 0 ? this.printMeasures.rpm_ap_angle.toString() : '';
	}
	/**
	* Get wedge angle in LAT view.
	*/
	get lt_wedgeAngle(): string {
		return this.printMeasures?.rpm_lt_angle || this.printMeasures?.rpm_lt_angle === 0 ? this.printMeasures.rpm_lt_angle.toString() : '';
	}
	/**
	* Get cortex length in AP view.
	*/
	get ap_cortexLength(): string {
		return this.measureText(this.printMeasures?.rpm_ap_cortexLength, this.labels().WEDGE_TABLE_COMPONENT_LENGTHENING, this.labels().WEDGE_TABLE_COMPONENT_SHORTENING);
	}
	/**
	* Get cortex length in LAT view.
	*/
	get lt_cortexLength(): string {
		return this.measureText(this.printMeasures?.rpm_lt_cortexLength, this.labels().WEDGE_TABLE_COMPONENT_LENGTHENING, this.labels().WEDGE_TABLE_COMPONENT_SHORTENING);
	}
	/**
	* Get axial length in AP view.
	*/
	get ap_axialLength(): string {
		return this.measureText(this.printMeasures?.rpm_ap_axialLength, this.labels().WEDGE_TABLE_COMPONENT_LENGTHENING, this.labels().WEDGE_TABLE_COMPONENT_SHORTENING);
	}
	/**
	* Get axial length in LAT view.
	*/
	get lt_axialLength(): string {
		return this.measureText(this.printMeasures?.rpm_lt_axialLength, this.labels().WEDGE_TABLE_COMPONENT_LENGTHENING, this.labels().WEDGE_TABLE_COMPONENT_SHORTENING);
	}
	/**
	* Get secondary translation in AP view.
	*/
	get ap_secondaryTransl(): string {
		return this.measureText(this.printMeasures?.rpm_ap_secondaryTransl, this.labels().WEDGE_TABLE_COMPONENT_MEDIAL, this.labels().WEDGE_TABLE_COMPONENT_LATERAL);
	}
	/**
	* Get secondary translation in LAT view.
	*/
	get lt_secondaryTransl(): string {
		return this.measureText(this.printMeasures?.rpm_lt_secondaryTransl, this.labels().WEDGE_TABLE_COMPONENT_POSTERIOR, this.labels().WEDGE_TABLE_COMPONENT_ANTERIOR);
	}

	private measureText(value: number | undefined, label1: string, label2: string): string {
		if (value || value === 0) {
			const sign = value > 0 ? label1 : label2;
			return `${Math.abs(value)} ${sign}`;
		}
		return '';
	}

}
